export default [{
  path: '/appraise/provincial',
  component: () => import('../../pages/appraise/provincial.vue'),
  meta: {
    title: '综合监管考核',
    keepAlive: true
  }
},
  {
  path: '/appraise/provincialDetail',
  component: () => import('../../pages/appraise/provincialDetail.vue'),
    meta: {
      title: '综合监管考核',
      keepAlive: true
  }
  },
  {
    path: '/appraise/deductionDetail',
    component: () => import('../../pages/appraise/deductionDetail.vue'),
    meta: {
      title: '扣分详情'
    }
  },
  {
  path: '/appraise/scoringList',
  component: () => import('../../pages/appraise/scoringRubric.vue'),
    meta: {
      title: '评分细则'
  }
  },
  {
  path: '/appraise/scoringDetail',
  component: () => import('../../pages/appraise/scoringDetail.vue'),
    meta: {
      title: '评分细则'
  }
  },
  {
  path: '/appraise/ranking',
  component: () => import('../../pages/appraise/ranking.vue'),
    meta: {
      title: '综合监管考核'
  }
  },
  {
  path: '/appraise/deductionList',
  component: () => import('../../pages/appraise/deductionList.vue'),
    meta: {
      title: '扣分列表'
  }
  },
  {
  path: '/appraise/deductionList-no',
  component: () => import('../../pages/appraise/deductionList-no.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionDetail-no',
  component: () => import('../../pages/appraise/deductionDetail-no.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/complainList',
  component: () => import('../../pages/appraise/complainList.vue'),
    meta: {
      title: '投诉列表'
  }
  },
  {
  path: '/appraise/deductionList-travel',
  component: () => import('../../pages/appraise/deductionList-travel.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionDetail-travel',
  component: () => import('../../pages/appraise/deductionDetail-travel.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/scoreList',
  component: () => import('../../pages/appraise/scoreList.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionList-safe',
  component: () => import('../../pages/appraise/deductionList-safe.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionDetail-safe',
  component: () => import('../../pages/appraise/deductionDetail-safe.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionList-situation',
  component: () => import('../../pages/appraise/deductionList-situation.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionDetail-situation',
  component: () => import('../../pages/appraise/deductionDetail-situation.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionList-negative',
  component: () => import('../../pages/appraise/deductionList-negative.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deductionDetail-negative',
  component: () => import('../../pages/appraise/deductionDetail-negative.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/complaintsRate',
  component: () => import('../../pages/appraise/complaintsRate.vue'),
    meta: {
      title: '扣分详情'
  }
  },
  {
  path: '/appraise/complaintsDisposal',
  component: () => import('../../pages/appraise/complaintsDisposal.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/complaintsSatisfaction',
  component: () => import('../../pages/appraise/complaintsSatisfaction.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/complaintsExperience',
  component: () => import('../../pages/appraise/complaintsExperience.vue'),
  meta: {
  }
  },
  {
  path: '/appraise/deducList-all',
  component: () => import('../../pages/appraise/deducList-all.vue'),
    meta: {
      title: ''
  }
  },
  {
  path: '/appraise/search',
  component: () => import('../../pages/appraise/search.vue'),
    meta: {
      title: '搜索'
  }
  }
]
